import { Button, Menu, Stack } from "@mui/material";
import PropTypes from "prop-types";
import { useState, useEffect } from "react";

PopoutLinkSet.propTypes = {
  open: PropTypes.bool,
  close: PropTypes.func,
  quillRef: PropTypes.object
}

export default function PopoutLinkSet({ open, close, quillRef })
{
  const [linkValue, setLinkValue] = useState('');
  const [quillSelection, setQuillSelection] = useState({});
  const [activeElement, setActiveElement] = useState(null);

  useEffect(() => {
    const selectedRange = open ? quillRef?.current?.editor?.getSelection() ?? {} : {};
    setQuillSelection(selectedRange);
    const activeNode = open && selectedRange.length > 0 ? window.getSelection().anchorNode.parentNode : null;
    setActiveElement(activeNode);
    const initCont = open && selectedRange.length > 0 ? quillRef.current.editor.editor.getContents(selectedRange.index, selectedRange.length) : null;
    if (initCont && initCont.ops && initCont.ops.every(op => op?.attributes?.link)) {
      quillRef.current.editor.formatText(selectedRange.index, selectedRange.length, 'link', "");    
      close();
    } setLinkValue(open && selectedRange.length > 0 ? quillRef.current.editor.getText(selectedRange.index, selectedRange.length) : "");
  }, [open]);

  if (!open || !quillRef?.current || !quillSelection.length) return null;

  const insertLink = () => { 
    quillRef.current.editor.formatText(quillSelection.index, quillSelection.length, 'link', linkValue)
    close();
  };

  return (
    <Menu anchorEl={activeElement} open={!!activeElement} anchorOrigin={{ vertical: "bottom", horizontal: "left" }} onClose={close}>
      <Stack direction="row" sx={{ px: 1, backgroundColor: "white" }} spacing={1}>
        <span>Enter link:</span>      
        <input
          type="text"
          placeholder="Link"
          value={linkValue}
          onChange={e => setLinkValue(e.target.value)}
        />
        <Button variant="text" sx={{ p: 0 }} disableRipple type="button" color="info" onClick={insertLink}>Save</Button>
      </Stack>
    </Menu>
  );
};